/**
 * TASKS-DRAFT.WIDGET
 * Create action plan from topics
 */

import { connect } from "react-redux"
import { ActionPlanState, ActionPlanTask } from "@/redux/action-plan.types"
import { WithTranslation, withTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import PageLoader from "@/components/page-loader"
import { TopicState } from "@/redux/topic.types"
import { SurveyState } from "@/redux/survey.types"
import Card from "@/components/card"
import ListItem from "@/components/list-item"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { store } from "@/core/root-reducer"
import { topicOpen } from "@/redux/topic.actions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import TasksEditModal from "@/modals/tasks-edit.modal"
import TasksCardWidget from "./tasks-card.widget"
import { FilterState } from "@/redux/filter.types"
import { INSUFFICIENT_PARTICIPATION } from "@/redux/_status.types"
import NoResultsWidget from "./no-results.widget"
import DashboardTopicWidget from "./dashboard-topic.widget"
import { Axis } from "@/redux/axis.types"
import { orderBy } from "lodash"

interface StateProps extends WithTranslation {
  _session: Session
  actionPlan: ActionPlanState
  survey: SurveyState
  topic: TopicState
  filter: FilterState
}

type ModalName = "MODAL_ADD" | "MODAL_ASSISTANT" | "MODAL_TOPIC"

function TasksDraftWidget(props: StateProps) {
  const { t } = props

  const [modal, setModal] = useState<ModalName | null>(null)

  //Sort by lowest first
  const topics = orderBy(props.topic.list, ["withScore", "note"], ["desc", "asc"])

  return (
    <div>
      {modal === "MODAL_ADD" && <TasksEditModal onClose={() => setModal(null)} />}

      <div className="flex mt-20">
        <div className="flex1">
          <h3>{`Résultats de l'enquête`}</h3>
          <p className="text-sm mb-20">{`Réponses des collaborateurs par question`}</p>
          <PageLoader status={props.topic.status} forceLoading>
            {props.topic.status === INSUFFICIENT_PARTICIPATION ? (
              <NoResultsWidget />
            ) : (
              <Card isWithoutPadding>
                {topics.map((topic, i) => (
                  <ListItem
                    key={topic.id}
                    isEditable
                    onClick={!topic.open ? () => store.dispatch(topicOpen(topic)) : undefined}>
                    <div className="flex1">
                      <DashboardTopicWidget
                        addTasks
                        addTaskActive={i === 0 && props.actionPlan.active.tasks.length === 0}
                        currentTopic={topic}
                        currentAxis={topic.Axis ?? new Axis()}
                        isEditable
                        onOpen={() => store.dispatch(topicOpen(topic))}
                      />
                    </div>
                  </ListItem>
                ))}
              </Card>
            )}
          </PageLoader>
        </div>
        <div className="min-w-20" />
        <div className="w-[360px] min-w-[360px]">
          <h3>{t(`tasks_list`)}</h3>
          <p className="text-sm mb-20">{`Ce plan d'action sera partagé avec votre responsable RH`}</p>
          <div className="upload-button medgrey-b flex flex-dcol !py-[16px] !px-20" style={{ height: "initial" }}>
            {props.actionPlan.active.tasks.map((task: ActionPlanTask, i: number) => (
              <TasksCardWidget key={task.id} draggableIndex={i} currentTask={task} />
            ))}

            {props.actionPlan.active.tasks.length === 0 && (
              <div className="flex">
                <div className="grey-t text-center">
                  <p>
                    <b>{t("tasks_list_empty")}</b>
                  </p>
                  <p className="text-sm my-20">
                    {t(`tasks_list_add_help`)}
                    <FontAwesomeIcon icon={faPlus} />
                    {`).`}
                  </p>
                </div>
                <div className="min-w-20" />
                <img
                  alt="error"
                  height="140"
                  src={require("@/assets/assistant/owl_female.png")}
                  className="-scale-x-100 mt-10"></img>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  actionPlan: state.actionPlan,
  survey: state.survey,
  topic: state.topic,
  filter: state.filter
})

export default connect(mapStateToProps)(withTranslation()(TasksDraftWidget))
